import React from "react";

export const FacebookIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.872"
      height="27.873"
      viewBox="0 0 27.872 27.873"
    >
      <path
        data-name="Icon awesome-facebook-square"
        d="M24.886,2.25H2.986A2.986,2.986,0,0,0,0,5.236v21.9a2.986,2.986,0,0,0,2.986,2.986h8.539V20.647H7.606v-4.46h3.92v-3.4c0-3.867,2.3-6,5.828-6a23.745,23.745,0,0,1,3.454.3v3.8H18.862a2.23,2.23,0,0,0-2.515,2.41v2.9h4.279l-.684,4.46H16.347v9.476h8.539a2.986,2.986,0,0,0,2.986-2.986V5.236A2.986,2.986,0,0,0,24.886,2.25Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  );
};
